import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  makeStyles,
  Typography,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  DialogActions,
  useTheme,
  Box,
  Button,
  SvgIcon
} from '@material-ui/core';
import red from '@material-ui/core/colors/red';
import { Timer as TimeIcon} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  boxWrapper: {
    width: '500px'
  },
  textTop: {
    marginBottom: '20px',
    textAlign: 'center'
  },
  textBottom: {
    marginBottom: '20px',
    textAlign: 'center'
  },
  logout: {
    color: '#fff',
    backgroundColor: 'red',
    '&:hover': {
      backgroundColor: red[700]
    }
  },
  button: {
    borderRadius: 0,
    textTransform: 'none',
    padding: 5
  },
  counter:{
      color:'red',
      marginLeft:'4px'
  }
}));

const IdleModal = ({ onApply, onClose, open, counter, handleLogout,handleContinue }) => {
  const classes = useStyles();
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Dialog maxWidth="lg" onClose={onClose} open={open}>
      <Box className={!mobileDevice ? classes.boxWrapper : undefined}>
        <DialogTitle className={classes.title}>
          <Box display="flex" alignItems="center" justifyContent="center">
          <Box mr={1} mt={1}>
            <SvgIcon>
              <TimeIcon />
            </SvgIcon>
          </Box>
            <Typography variant="h4" color="textPrimary">
              Session Timeout
            </Typography>

          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Typography
            variant="h5"
            className={classes.textTop}
            color="textPrimary"
          >
            You have been idle, your current session is about to expire in

            <span className={classes.counter}>{counter}</span>
          </Typography>
          <Typography variant="body2" className={classes.textBottom}>
            Would you like to continue the session?
          </Typography>
        </DialogContent>
        <DialogActions>
          {/* <Button
            variant="contained"
            onClick={handleLogout}
            className={classes.logout}
          >
            Logout
          </Button> */}
          <Button color="primary"
          onClick={handleContinue}
           variant="contained">
            Continue Session
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

IdleModal.propTypes = {
  onApply: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired
};

IdleModal.defaultProps = {
  onApply: () => {},
  onClose: () => {}
};

export default IdleModal;
